export interface SwMessage {
  type: string;
}

export class SwInstalledMessage implements SwMessage {
  static messageType = 'SwInstalledMessage';

  type = SwInstalledMessage.messageType;
}

export class ApplyUpdatesMessage implements SwMessage {
  static messageType = 'ApplyUpdatesMessage';

  type = ApplyUpdatesMessage.messageType;
}
